export interface HomepageBrand {
  link?: string;
  altName: string;
  brand: string;
  image: string;
  isExternal?: boolean;
  pinned?: boolean;
}

export const homePageBrands: HomepageBrand[] = [
  {
    link: "/products/biz-collection?page=1",
    altName: "Biz Collection",
    brand: "biz-collection",
    image:
      "https://cdn.fashionbiz.com/bizz-react/brands/FB_Homepage Assets_Browse by Brands 2026_Biz Collection-updated.jpg",
  },
  {
    link: "/products/biz-corporates?page=1",
    altName: "Biz Corporates",
    brand: "biz-corporates",
    image:
      "https://cdn.fashionbiz.com/bizz-react/brands/FB_Homepage Assets_Browse by Brands 2026_Biz Corporates - updated.jpg",
  },
  {
    link: "/products/syzmik?page=1",
    altName: "Syzmik",
    brand: "syzmik",
    image:
      "https://cdn.fashionbiz.com/webstore/Homepage Assets - Browse By Brand - Syzmik 2026.jpg",
  },
  {
    link: "/products/inaura?page=1",
    altName: "Inaura",
    brand: "inaura",
    image:
      "https://cdn.fashionbiz.com/bizz-react/brands/Homepage Assets - Browse By Brand - Inaura.jpg",
  },
  {
    link: "/products/good-mates?page=1",
    altName: "GOODMATES",
    brand: "good-mates",
    image:
      "https://cdn.fashionbiz.com/bizz-react/brands/Homepage Assets - Browse by Brands - GM.jpg",
  },
  {
    link: "/search?q=hospitality&page=1",
    altName: "Yes-Chef",
    brand: "yes-chef",
    image:
      "https://cdn.fashionbiz.com/bizz-react/brands/Homepage Assets - Browse By Brand - YC 2025.jpg",
    pinned: true,
  },
  {
    altName: "Biz Co.Lab",
    brand: "biz-co-lab",
    image:
      "https://cdn.fashionbiz.com/bizz-react/brands/Homepage Assets - Browse By Brand - BCL 2025.jpg",
    isExternal: true,
    pinned: true,
  },
];
